export const baseSpacingUnit = 4

export const spacing = {
  tiny: baseSpacingUnit,
  small: baseSpacingUnit * 2,
  base: baseSpacingUnit * 3,
  large: baseSpacingUnit * 6,
  'x-large': baseSpacingUnit * 8
}
